export const FEATURE_NAME = '@zerops/zerops/feature/user-data-edit-dialog';
